<h1 mat-dialog-title fxLayoutAlign="center">
  <div fxFlex="91.44px"></div>
  <div fxFlex="grow" fxLayoutAlign="center">End User License Agreement and Terms of Service</div>
  <div fxFlex="noshrink" fxFlexAlign="end end">
    <button mat-button mat-dialog-close>Close<mat-icon>clear</mat-icon></button>
  </div>
</h1>
<div mat-dialog-content class="content">
  <p class="new-line">
    This End User License Agreement and Terms of Service (the “Agreement”) is a legal agreement between the entity
    for whose benefit you act (“you” or “Customer”) and <span class="bold-font">Veil Global Technologies, Inc.</span> (“Veil”)
    (together the “Parties” and individually a “Party”).
  </p>
  <p class="new-line">
    <span>By indicating your acceptance by clicking on the appropriate button below or by activating, or using Veil’s Bundled Services,
      Customer is agreeing to be bound by this Agreement, and the individual acting on behalf of Customer is authorized to do so.</span>
  </p>
  <p class="new-line">
    <span class="bold-font">1. Definitions</span>
  </p>
  <p class="new-line">
    For the purposes of this Agreement, the following definitions apply:
  </p>
  <ul>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Access Credentials</span>: Means any username, identification number, password, license or security key, security token, PIN,
    or other security code, method, technology, or device used alone or in combination to verify a user’s authorization to access and use the Bundled Services.
    </li>
  </p>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Authorized User</span>: Means each of the individuals authorized to use the Bundled Services with the Access Credentials.
    </li>
  </p>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Bundled Services</span>: Refers to the Licensed Enabling Code, Software, and Hosted Services,
    and any additional services as listed in the License Agreement.
    </li>
  </p>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Confidential Information</span>: Means any information in any form or medium (whether oral, written, electronic, or other)
    that the Disclosing Party considers confidential or proprietary, including information consisting of or relating to the Disclosing Party’s
    technology, trade secrets, business operations, plans, strategies, customers, pricing, or other information that is marked as “confidential”
    or that a reasonable person would understand to be confidential.
    </li>
  </p>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Customer Data</span>: Refers to business data, proprietary information, or other content supplied by the Customer to the platform solely for the purpose of enabling the Bundled Services to perform in accordance with this Agreement.
    Customer Data remains the property of the Customer and is used solely as needed to generate the desired output from the Bundled Services.
    </li>
  </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Customer Systems</span>: Means the Customer’s information technology infrastructure, including computers, software, hardware, databases, electronic systems (including database management systems), and networks, whether operated directly by Customer or through the use of third-party services.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Documentation</span>: Means any manuals, instructions, or other documents or materials that Veil provides or makes available to Customer in any form or medium and which describe the functionality, components, features, or requirements of the Bundled Services or Veil Materials, including any aspect of the installation, configuration, integration, operation, use, support, or maintenance thereof.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Fees</span>: Refers to the fees Customer must pay Veil for access to and use of the Bundled Services as set forth in the License Agreement.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Force Majeure Event</span>: Means an event beyond the reasonable control of a party that prevents or delays its performance under this Agreement, including but not limited to natural disasters, acts of war, terrorism, labor disputes, government-imposed restrictions, cyber-attacks, and other similar events.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Hosted Services</span>: Refers to the electronic access provided by Veil to the Software through the internet.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Initial Term</span>: Has the meaning set forth in Section 5.2, referring to the initial duration of the Agreement.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Intellectual Property Rights</span>: Refers to any and all rights granted, applied for, or otherwise now or hereafter in existence under or related to any patent, copyright, trademark, trade secret, database protection, or other intellectual property rights laws, and all similar or equivalent rights or forms of protection in any part of the world.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">License Agreement</span>: Refers to the agreement between Veil and Customer that outlines the specific details, including the services provided and the fees involved.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Licensed Enabling Code</span>: Refers to the Veil JavaScript enabling code and all new versions, updates, revisions, improvements, and modifications thereof, which enables Software and Hosted Services functionality.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Permitted Use</span>: Refers to the use of the Bundled Services by Authorized Users using Access Credentials solely for Customer’s internal business operations, as specified in this Agreement.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Resultant Data</span>: Means data and other information relating to the provision, use of the Software, and performance of the Bundled Services, including Customer Data that is de-identified and recorded by Veil.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Software</span>: Refers to the software that enables the collection and display of commercial detection events along with the synchronization, matching resolution, and change management of broadcast advertisements between purchased expected airings and actual detected commercial airings, and all new versions, updates, revisions, improvements, and modifications thereof, provided to Customer by Veil through the Hosted Services.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Subcontractor</span>: Refers to any third party engaged by Veil to perform certain services under this Agreement.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Term</span>: Refers to the duration of this Agreement as specified in Section 5.2.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Third-Party Platforms</span>: Means the technology, materials, and information in any form or medium, including any open-source or other software, documents, data, content, specifications, products, equipment, or components that are not proprietary to Veil and which may be used by or accessed in connection with the Bundled Services, including but not limited to platforms of third-party providers of marketing and/or advertising technologies, tracking technologies, analytics, or on-site optimization technologies.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        <span class="bold-font">Veil Data</span>: Refers to all proprietary data, content, information, or materials owned by Veil, including any data generated by Veil’s systems, algorithms, or technology. This also includes all outputs, results, analyses, or derivative works created through the use of Veil’s Bundled Services, whether generated solely from Veil Data or from a combination of Veil Data and Customer Data.
      </li>
    </p>
  </ul>

  <p class="new-line">
    <span class="bold-font">2. License</span>
  </p>
  <p class="new-line">
    Veil hereby grants Customer a limited, revocable, non-exclusive, non-transferable license to access and use <span class="bold-font">Veil Data</span>
    and the Bundled Services solely for the business purposes described in the License Agreement. Customer may provide <span class="bold-font">Customer Data</span>
    to the platform, which may be processed or used in conjunction with <span class="bold-font">Veil Data</span> to achieve the Customer’s desired outcomes.
  </p>
  <p class="new-line def-indent">
    <span class="bold-font">2.1 Ownership of Data</span>
  </p>
  <ul>
  <p class="new-line def-indent">
    <li>
    <span class="bold-font">Veil Data</span>: Veil retains full ownership of all <span class="bold-font">Veil Data</span>,
      including any modifications, updates, enhancements, or derivative works produced by or through the Bundled Services.
      <span class="bold-font">All results, outputs, and data products generated by the platform, even those using or incorporating Customer Data, are owned exclusively by Veil.</span>
      Customer is granted a limited license to use these outputs solely for its internal business purposes, as agreed upon in this Agreement. Under no circumstances does the Customer obtain any ownership rights to Veil Data or the results generated by the platform.
    </li>
  </p>
  <p class="new-line def-indent">
    <li>
      <span class="bold-font">Customer Data</span>: Customer retains ownership of all <span class="bold-font">Customer Data</span> that it provides to the platform. By submitting Customer Data, Customer grants Veil a non-exclusive, royalty-free, worldwide, irrevocable license to process, store, and use the Customer Data solely as needed to provide the Bundled Services.
      This license extends to the combination of Customer Data with Veil Data as necessary to deliver the agreed-upon results.
      <span class="bold-font">Veil does not claim ownership over Customer Data</span>, but Customer agrees that any outputs resulting from the use of both Veil Data and Customer Data are owned solely by Veil.
    </li>
  </p>
  </ul>

  <p class="new-line">
    <span class="bold-font">3. Data Handling and Privacy</span>
  </p>
  <p class="new-line">
    Veil agrees to comply with applicable data protection laws relevant to B2B transactions. No personally identifiable information (PII) will be handled by the platform.
    The platform processes only <span class="bold-font">Veil Data</span> and <span class="bold-font">Customer Data</span> for the purposes of providing business outcomes.
    Both parties agree to safeguard all data processed under this Agreement in accordance with applicable data protection and confidentiality laws.
  </p>
  <p class="new-line">
    <span class="bold-font">4. Electronic Notices and Signatures</span>
  </p>
  <p class="new-line">
    Customer agrees to receive all notices electronically, including business-related updates, invoices, and contractual communications. All communications will be between authorized business representatives and Veil. The use of electronic signatures for all agreements between the parties is valid and enforceable under the federal Electronic Signatures in Global and National Commerce Act, state enactments of the Uniform Electronic Transactions Act, or any other relevant and applicable electronic signatures law.
  </p>

  <p class="new-line">
    <span class="bold-font">5. Terms of Service</span>
  </p>
  <p class="new-line">
    <span class="bold-font">5.1 Permitted Use of Bundled Services</span>
  </p>
  <p class="new-line">
    During the Term, Veil authorizes Customer to access and use the Software through the Licensed Enabling Code and Hosted Services solely for the Permitted Use by Authorized Users and subject to the conditions set forth in this Agreement. This authorization is non-exclusive and non-transferable.
  </p>
  <p class="new-line">
    <span class="bold-font">5.2 Availability</span>
  </p>
  <p class="new-line">
    Veil will use commercially reasonable efforts to make the Bundled Services available at all times. However, Veil makes no guarantee of uninterrupted use or operation of the Bundled Services. Veil may temporarily or permanently suspend the Bundled Services for service improvements, maintenance, or repair, or for any other reason beyond Veil’s control.
  </p>
  <p class="new-line">
    <span class="bold-font">5.3 Access and Security</span>
  </p>
  <p class="new-line">
    Customer shall employ all necessary safeguards, including physical, administrative, and technical controls, to protect access to the Bundled Services and prevent unauthorized access to Veil Data.
  </p>
  <p class="new-line">
    <span class="bold-font">6. Force Majeure</span>
  </p>
  <p class="new-line">
    Force Majeure events include, but are not limited to, natural disasters, cyber-attacks, economic disruptions, government-imposed restrictions, and any other event beyond the reasonable control of the affected party that impacts business operations or the ability to process business data. In no event will either Party be liable or responsible to the other Party or be deemed to have defaulted under or breached this Agreement for any failure or delay in fulfilling or performing any term of this Agreement (except for payment obligations) when such failure or delay is caused by any Force Majeure Event.
  </p>

  <p class="new-line">
    <span class="bold-font">7. Third-Party Platforms</span>
  </p>
  <p class="new-line">
    Customer remains solely responsible for ensuring that any Customer Data processed through third-party platforms integrated with the Bundled Services complies with all applicable regulations. Veil is not responsible for any third-party platform failures, inaccuracies, or security breaches and provides no warranties related to such third-party services. Customers should ensure that third-party services integrated with the Bundled Services comply with any business-specific data protection and confidentiality requirements.
  </p>

  <p class="new-line">
    <span class="bold-font">8. Idemnification</span>
  </p>
  <p class="new-line">
    <span class="bold-font">8.1 Customer Idemnification</span>
  </p>

  <p class="new-line">
    Customer agrees to indemnify and hold harmless Veil and its officers, directors, employees, agents, and representatives from and against any and all claims, liabilities, damages, losses, and expenses (including reasonable attorney’s fees) arising from or relating to:
  </p>

  <ul>
    <p class="new-line def-indent">
      <li>
        Any intellectual property disputes or claims related to Customer Data, including the unauthorized use, sharing, or breach of business data processed through the platform.
      </li>
    </p>
    <p class="new-line def-indent">
      <li>
        Any breach of this Agreement or violation of applicable laws by the Customer or its Authorized Users.
      </li>
    </p>
  </ul>

  <p class="new-line">
    <span class="bold-font">8.2 Veil Idemnification</span>
  </p>
  <p class="new-line">
    Veil shall indemnify and hold harmless Customer from and against any and all claims, liabilities, damages, losses, and expenses (including reasonable attorney’s fees) arising from any claims that the Bundled Services or Veil Data infringe U.S. Intellectual Property Rights, provided such claims pertain solely to business data processed under this Agreement.
  </p>

  <p class="new-line">
    <span class="bold-font">9. Data Breach Notification</span>
  </p>
  <p class="new-line">
    In the event of a data breach involving <span class="bold-font">Veil Data</span> or <span class="bold-font">Customer Data</span>, including proprietary information or trade secrets, Veil will promptly notify the Customer and take all reasonable steps to mitigate any damage. The notification will comply with applicable laws concerning business data breaches.
  </p>

  <p class="new-line">
    <span class="bold-font">10. Confidentiality</span>
  </p>
  <p class="new-line">
    Each party agrees to protect the confidentiality of all business information, trade secrets, and proprietary data shared under this Agreement. Customer Data will be treated as confidential and will not be used outside of the scope of this Agreement. Both parties shall take reasonable measures to prevent unauthorized disclosure or use of any Confidential Information received from the other.
  </p>

  <p class="new-line">
    <span class="bold-font">11. Dispute Resolution and Governing Law</span>
  </p>
  <p class="new-line">
    <span class="bold-font">11.1 Governing Law</span>
  </p>
  <p class="new-line">
    This Agreement, including its validity and interpretation, shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflicts of law principles.
  </p>
  <p class="new-line">
    <span class="bold-font">11.2 Arbitration and Venue</span>
  </p>
  <p class="new-line">
    Any dispute arising out of or related to this Agreement, which concerns business data or related commercial matters, shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association (AAA). Arbitration shall take place in New York, New York, or as mutually agreed upon by the parties.
  </p>
  <p class="new-line">
    In the event of any legal action related to this Agreement, the Parties hereby consent to the exclusive jurisdiction of the courts of the State of New York located in New York, NY.
  </p>

  <p class="new-line">
    <span class="bold-font">12. Changes to Agreement</span>
  </p>
  <p class="new-line">
    Except to the extent that Veil is expressly precluded by law, Veil reserves the right to make changes to this Agreement to reflect changes in business practices or as required by law, by providing Customer with reasonable notice of the change. If Customer continues to use the Bundled Services for more than thirty (30) days after notice of the change, Customer shall be deemed to have accepted such changes.
  </p>

  <p class="new-line">
    <span class="bold-font">13. Miscellaneous</span>
  </p>
  <p class="new-line">
    <span class="bold-font">13.1 Severability</span>
  </p>
  <p class="new-line">
    If any provision of this Agreement is found to be invalid, illegal, or unenforceable, such provision shall be limited or eliminated to the minimum extent necessary so that the Agreement shall otherwise remain in full force and effect.
  </p>

  <p class="new-line">
    <span class="bold-font">14. Conflict Between Agreements</span>
  </p>
  <p class="new-line">
    In the event of any inconsistency or conflict between the provisions of this Agreement and those of the Customer’s License Agreement, the terms and conditions set forth in the Customer’s License Agreement shall govern and control.
  </p>




<div mat-dialog-actions>
  <button *ngIf="needAccept" mat-raised-button color="primary" [mat-dialog-close]="true">Accept</button>
</div>
</div>